import styled, {createGlobalStyle} from "styled-components";
import "@fontsource/kaushan-script";


const GlobalStyles = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    overflow: ${props => props.scroll && 'hidden'};
    text-decoration: none;
    list-style: none;
    color: inherit;
    @media (max-width: 768px){
     overflow-x: hidden;

    }
  }
  // Need renseignement
  .me {
    display: flex;
    align-items: center;
  }
`

export const LineMailHome = styled.div`
  width: 40px;
  position: fixed;
  right: 40px;
  left: auto;
  z-index: 100;
  bottom:0;
  &::after {
    content: "";
    display: block;
    width: 2px;
    height: 90px;
    margin: 0px auto;
    background: grey;
    z-index: 4;
  }

  p{
    transform: rotate(90deg) translateX(-238px);
    font-family: "Avenir Heavy",sans-serif;
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: 300;
  }

  p:hover{
    transform: rotate(90deg) translateX(-310px) scale(1.2);
  }

  @media (max-width: 768px){
      display: none;
      visibility: hidden;
   
}
`

export const TitleSection = styled.h1`
  overflow: hidden;
  font-family: "Oswald",sans-serif;
  color: rgba(106, 105, 105, 0.16);
  font-weight: 500;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  font-size:${props => props.theme.fontbig}; ;

    @media (max-width:48em) {
        font-size:${props => props.theme.fontxxl};
    }
    
`




export default GlobalStyles;